import { useEffect } from 'react';
import { useTracking } from 'react-tracking';
import { Phone } from '@phosphor-icons/react';
import { Text, Box, Palette } from '@updater/ui-uds';
import { PageHeading } from '@updater/ui-widgets';
import { CallRailPhone, CallRailComponentType } from 'components';

export function LeadError() {
  const { trackEvent } = useTracking({
    object: 'lead_mode_error',
  });

  // Track view event after mount (empty dep array to run once)
  useEffect(() => {
    trackEvent({
      verb: 'viewed',
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Box paddingY="xxl">
      <Box maxWidth="914px">
        <PageHeading data-testid="could-not-process-header">
          We&apos;re sorry, your order could not be processed online.
        </PageHeading>
        <Text variant="l" marginTop="l" marginBottom="m">
          But we&apos;re here to help! Call us now at the number below to speak
          with an agent directly:
        </Text>
        <Box minWidth="324px" maxWidth={['auto', null, null, null, '324px']}>
          <CallRailPhone
            componentType={CallRailComponentType.BUTTON}
            text="Call ###"
            variant="l"
            icon={<Phone size="24" weight="fill" />}
          />
        </Box>
        <Text variant="m" color={Palette.gray800} marginTop="m">
          Mon-Fri 7am to 1am EST & Sat-Sun 7am to 11pm EST
        </Text>
      </Box>
    </Box>
  );
}
